import React from 'react';
import { Reveal } from './Reveal';
export function SectionEyebrow({
  label,
  align = 'left'
}: {
  label: string;
  align?: 'left' | 'center';
}) {
  return <Reveal anim="slideInLeft" data-id="element-211" data-mp="1djr01sxs4bqy">
      <div className={`flex items-center gap-4 ${align === 'center' ? 'justify-center' : ''}`} data-id="element-212" data-mp="1rd04df6ve72m">
        <span className="whitespace-nowrap text-[13px] font-bold uppercase tracking-[0.25em] text-[#FFB700]" data-id="element-213" data-mp="1nbwr90g7ip53">{label}</span>
        <span className="h-px max-w-[420px] flex-1 bg-[#FFB700]/60" data-id="element-214" data-mp="zlakdchxvawo" />
      </div>
    </Reveal>;
}